class PredictiveSearch extends HTMLElement {
  constructor() {
    super();

    this.input = this.querySelector('input[type="search"]');
    this.predictiveSearchResults = this.querySelector('#predictive-search');
    this.form = this.querySelector('form');

    this.input.addEventListener('input', this.debounce((event) => {
      this.onChange(event);
    }, 300).bind(this));

    // Prevent form submission when predictive search is open
    this.form.addEventListener('submit', this.onFormSubmit.bind(this));

    // Close when clicking outside
    document.addEventListener('click', this.onClickOutside.bind(this));

    // Close when pressing Escape
    this.input.addEventListener('keydown', (event) => {
      if (event.key === 'Escape') {
        this.close();
        this.input.blur();
      }
    });
  }

  onChange() {
    const searchTerm = this.input.value.trim();

    if (!searchTerm.length) {
      this.close();
      return;
    }

    if (searchTerm.length >= 2) {
      this.getSearchResults(searchTerm);
    }
  }

  onFormSubmit(event) {
    // Se o predictive search estiver aberto e houver resultados, prevenir submit
    if (this.predictiveSearchResults.style.display === 'block' && this.predictiveSearchResults.innerHTML.trim() !== '') {
      event.preventDefault();
    }
  }

  onClickOutside(event) {
    // Close if clicking outside the predictive search element
    if (!this.contains(event.target)) {
      this.close();
    }
  }

  getSearchResults(searchTerm) {
    const rootUrl = window.Shopify && window.Shopify.routes && window.Shopify.routes.root ? window.Shopify.routes.root : '/';
    fetch(`${rootUrl}search/suggest?q=${encodeURIComponent(searchTerm)}&resources[type]=product,collection,page&resources[limit]=4&section_id=predictive-search`)
      .then((response) => {
        if (!response.ok) {
          var error = new Error(response.status);
          this.close();
          throw error;
        }

        return response.text();
      })
      .then((text) => {
        const resultsMarkup = new DOMParser().parseFromString(text, 'text/html').querySelector('#shopify-section-predictive-search');
        if (resultsMarkup) {
          this.predictiveSearchResults.innerHTML = resultsMarkup.innerHTML;
          this.open();
        } else {
          this.close();
        }
      })
      .catch((error) => {
        if (error.name !== 'AbortError') {
          console.error('Predictive search error:', error);
        }
        this.close();
      });
  }

  open() {
    this.predictiveSearchResults.style.display = 'block';
    this.input.setAttribute('aria-expanded', 'true');
  }

  close() {
    this.predictiveSearchResults.style.display = 'none';
    this.input.setAttribute('aria-expanded', 'false');
  }

  debounce(fn, wait) {
    let t;
    return (...args) => {
      clearTimeout(t);
      t = setTimeout(() => fn.apply(this, args), wait);
    };
  }
}

customElements.define('predictive-search', PredictiveSearch);